import React, { useState } from "react";
import { SMLogo } from "@/components/UIBits";
import { DesignField } from "@/components/DesignField";
import { T, fmt } from "@/lib/copy";

// Landing page — /design layout (rWelcome), spec content (logo + Hinglish-primary + Devanagari + toggle).
const DEVA_TAGLINE = "अगला बड़ा खिलाड़ी कहीं से भी हो सकता है।";

export default function Welcome({ lang, setLang, onStart, onMeet, challenger, streak = 0, meetSeen = false }) {
  const t = T(lang);
  const [name, setName] = useState(() => {
    try { return localStorage.getItem("so_name") || ""; } catch (e) { return ""; }
  });
  const [returning] = useState(() => {
    try { return !!localStorage.getItem("so_name"); } catch (e) { return false; }
  });
  const steps = [t.step1, t.step2, t.step3];
  const nameValid = name.trim().length >= 1;
  const canProceed = returning ? true : (nameValid && meetSeen); // B47 mandate + B48 returning-user pass-through.
  const prompt = returning
    ? (streak >= 2 ? fmt(t.wPromptStreak, { name: name.trim(), n: streak }) : fmt(t.wPromptBack, { name: name.trim() }))
    : t.wPrompt;
  const ctaLabel = returning
    ? "Try another lens ▸" // B48
    : (!meetSeen ? "▶ Meet the Maidaan first" : (nameValid ? t.stepOnto : t.namePromptHint));
  function submitName() {
    if (!meetSeen) return; // B47: mandate — CTA is inert until Meet is seen.
    if (!nameValid) {
      const el = document.querySelector('[data-testid="welcome-name-input"]');
      if (el) el.focus();
      return;
    }
    const trimmed = name.trim();
    try { localStorage.setItem("so_name", trimmed); } catch (e) { /* noop */ }
    onStart(trimmed);
  }
  return (
    <div className="dwelcome" style={{ padding: "20px 24px 26px", position: "relative" }} data-testid="welcome-screen">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
        <SMLogo height={56} opacity={0.95} />
        {/* V2: <LangToggle lang={lang} setLang={setLang} /> — Desi deferred to V2. */}
      </div>

      <div className="wordmark" data-testid="wordmark">SUPER&nbsp;<span className="ring-dot" aria-hidden="true" />VER</div>
      <div className="kicker" style={{ marginTop: 8 }}>{t.daily}</div>
      <div className="deva-tag" style={{ marginTop: 7 }} data-testid="welcome-deva-tagline">{DEVA_TAGLINE}</div>

      <div style={{ display: "flex", gap: 6, marginTop: 14 }}>
        {steps.map((s, i) => (
          <div key={i} className="step-box">
            <div className="step-num">{i + 1}</div>
            <div className="step-label">{s}</div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 14 }}>
        <DesignField />
      </div>

      {challenger && (
        <div className="panel anim-fade" style={{ marginTop: 14, padding: 12, textAlign: "center" }} data-testid="welcome-challenger-panel">
          <div className="font-reading" style={{ fontSize: 13, color: "rgba(244,239,230,0.9)" }}>
            <b style={{ color: "var(--sm-blaze)" }}>{challenger.challenger_name}</b> chased {challenger.chase} and got <b>{challenger.challenger_score}</b>. Can you beat it?
          </div>
        </div>
      )}

      <div style={{ marginTop: 13, marginBottom: 11 }}>
        <div className="maidaan-line" style={{ fontSize: 15 }} data-testid="welcome-maidaan-line">
          {t.wLineA}
          <b style={{ color: "var(--sm-blaze)", fontWeight: 500 }}>{t.wLineName}</b>
          {t.wLineB}
          <b style={{ color: "var(--sm-chalk)", fontWeight: 500 }}>{t.wLineWatch}</b>
        </div>
        <button className={"btn-meet" + (meetSeen ? " seen" : "")} style={{ marginTop: 10, marginBottom: 2 }} onClick={onMeet} data-testid="welcome-meet-maidaan-button">
          {t.meet}
        </button>
        <div className="maidaan-prompt" style={{ fontSize: 22, marginTop: 12 }} data-testid="welcome-maidaan-prompt">{prompt}</div>
      </div>

      {/* B48: name input hidden for returning users (name pre-loaded from localStorage). */}
      {!returning && (
        <input
          className="name-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onFocus={(e) => e.target.select()}
          placeholder={t.namePh}
          maxLength={24}
          data-testid="welcome-name-input"
          onKeyDown={(e) => e.key === "Enter" && submitName()}
        />
      )}
      <button
        className="btn-primary"
        style={{ width: "100%", marginTop: 12, padding: 17, fontSize: 20, opacity: canProceed ? 1 : 0.55, cursor: canProceed ? "pointer" : "not-allowed" }}
        onClick={submitName}
        disabled={!canProceed}
        data-testid="welcome-primary-cta"
      >
        {ctaLabel}
      </button>
    </div>
  );
}

// V2: LangToggle (STUMP MIC · Desi | English) — dormant for V1 English-only launch. Restore for V2 bilingual.
// export function LangToggle({ lang, setLang }) {
//   return (
//     <div className="stump-mic-toggle" data-testid="lang-toggle">
//       <span className="stump-mic-kicker">STUMP MIC ·</span>
//       {["hi", "en"].map((l) => (
//         <button
//           key={l}
//           onClick={() => setLang(l)}
//           className={"stump-mic-pill" + (lang === l ? " active" : "")}
//           data-testid={"lang-toggle-" + l}
//         >
//           {l === "hi" ? "Desi" : "English"}
//         </button>
//       ))}
//     </div>
//   );
// }
